module.exports = __webpack_public_path__ + "img/login__background.c88aa499.png";